'use strict';
exports = module.exports = {
  en: require('./lang/translate.en.js')
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/languages.js
// module id = 73
// module chunks = 0